import React from 'react';

import useIsMobile from '@/src/hooks/useIsMobile';

import {ApplicationContainer} from '../../../ui';
import Footer from '../../footer/components/Footer';
import Header from '../../header/components/Header';
import SignUpBlock from '../../header/components/SignUpBlock';
import css from '../styles/authenticationLayout.module.css';

interface IAuthenticationLayoutProps {
  children: React.ReactNode;
  withSignUpButton?: boolean;
  logoLink?: string;
}

const AuthenticationLayout = ({
  children,
  withSignUpButton,
  logoLink,
}: IAuthenticationLayoutProps) => {
  const {isMaxWidth900} = useIsMobile();

  return (
    <ApplicationContainer>
      <div className={css.wrapper}>
        <Header withSignUpButton={withSignUpButton} logoLink={logoLink} />
        <div className={css.main}>{children}</div>
        {withSignUpButton && isMaxWidth900 && <SignUpBlock />}
        <Footer />
      </div>
    </ApplicationContainer>
  );
};

export default AuthenticationLayout;

AuthenticationLayout.defaultProps = {
  withSignUpButton: true,
  children: React.createElement('div'),
};
